<script lang="ts" setup>
import { storeToRefs } from 'pinia';

import {
  GrammarFooter,
  GrammarModal,
  GrammarPrimaryButton,
  GrammarSecondaryButton,
} from '@nora-monorepo/grammar-ui';

import { useConfirmModalStore } from '#ui-shared/components/modals/confirm-modal/confirm-modal-store';

const emits = defineEmits(['confirm', 'cancel']);

const confirmModalStore = useConfirmModalStore();
const { closeModal, handleConfirm } = confirmModalStore;

const {
  isOpen,
  headerText,
  bodyText,
  confirmButtonLabel,
  cancelButtonLabel,
  confirmButtonType,
} = storeToRefs(confirmModalStore);

function onCancelClick() {
  closeModal();
  emits('cancel');
}

function onConfirmClick() {
  handleConfirm();
  emits('confirm');
}
</script>

<template>
  <GrammarModal
    :is-open="isOpen"
    :label="headerText"
    :secondary-label="bodyText"
    :show-close-button="true"
    @close="onCancelClick"
  >
    <template #footer>
      <GrammarFooter>
        <template #left-button>
          <GrammarSecondaryButton
            :label="cancelButtonLabel"
            @click="onCancelClick"
          />
        </template>
        <template #right-button>
          <GrammarPrimaryButton
            :label="confirmButtonLabel"
            :type="confirmButtonType"
            @click="onConfirmClick"
          />
        </template>
      </GrammarFooter>
    </template>
  </GrammarModal>
</template>
